import { render, staticRenderFns } from "./order.vue?vue&type=template&id=8d5aa03e&scoped=true"
import script from "./order.vue?vue&type=script&lang=ts"
export * from "./order.vue?vue&type=script&lang=ts"
import style0 from "./order.vue?vue&type=style&index=0&id=8d5aa03e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5aa03e",
  null
  
)

export default component.exports